import React from 'react';
import { useLoaderData } from 'react-router-dom';
import ListPageHeader from '@shared/ListPageHeader';
import ThirdPartyApiLogShow from '@shared/third_party_api_logs/ThirdPartyApiLogShow';

export default function AdminThirdPartyApiLogsShow() {
  const log = useLoaderData();

  return (
    <div>
      <ListPageHeader basePath="/admin" items={['platform', 'platform.api_logs', { label: log?.id?.slice(0, 8) }]} />
      <ThirdPartyApiLogShow log={log} />
    </div>
  );
}
